module.exports = __webpack_public_path__ + "static/img/value_4.26a451a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/value_4.png
// module id = nfpy
// module chunks = 1